<style scoped lang="stylus">
    @import '../assets/css/theme.styl'
    .cus-tab-bar {
        height 50px
        .van-tabbar {
            background-color baseConBackColor
        }
        .van-tabbar--fixed:after {
            border none
        }
        .van-tabbar-item {
            color: #949494
            &.van-tabbar-item--active {
                color: #7DD3B4
                background-color: transparent;
                .van-tabbar-item__text {
                    color: #fff
                }
            }
        }
    }
</style>

<template>
    <div class="cus-tab-bar">
        <van-tabbar v-model="active" route fixed>
            <van-tabbar-item v-for="(item, index) in list" :key="index" :icon="item.icon" :to="item.routerName" replace>{{item.name}}</van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
    export default {
        props: [],
        components: {},
        data() {
            return {
                active: 0,
                list: [
                    {
                        name: '首页',
                        icon: 'home-o',
                        routerName: '/home',
                    },
                    {
                        name: '数据',
                        icon: 'cart-o',
                        routerName: '/order',
                    },
                    {
                        name: '统计',
                        icon: 'bar-chart-o',
                        routerName: '/order-count',
                    },
                    {
                        name: '我的',
                        icon: 'user-o',
                        routerName: '/my/index',
                    }
                ]
            };
        },
        created() {

        },
        mounted() {

        },
        computed: {},
        watch: {},
        methods: {},
    };
</script>
